import makeRequest from './api'
import endpoints from './endpoints'

export const submitPatientDetails = (params) => {
  return makeRequest('GET', endpoints.SUBMIT_PATIENT_DETAILS, params)
}

export const getPincodeDetails = (params) => {
  return makeRequest('GET', endpoints.GET_PINCODE_DETAILS, params)
}

export const getMedicalConditions = () => {
  return makeRequest('GET', endpoints.GET_MEDICAL_CONDITIONS)
}

export const requestCallback = (data) => {
  return makeRequest('POST', endpoints.REQUEST_CALLBACK, {}, data)
}

// AUTH APIS
export const sendOtp = async (payload) =>
  makeRequest('POST', endpoints.Auth.SEND_OTP, {}, payload)

export const verifyOtp = async (payload) =>
  makeRequest('POST', endpoints.Auth.VERIFY_OTP, {}, payload)

export const loginOrRegisterPatient = async (payload) =>
  makeRequest('POST', endpoints.Auth.LOGIN_OR_REGISTER_PATIENT, {}, payload)

export const updateUser = async (payload) =>
  makeRequest('POST', endpoints.Auth.UPDATE_USER, {}, payload)

// DIAGNOSTICS APIS
export const updateAddress = async (payload) =>
  makeRequest('POST', endpoints.Diagnostics.UPDATE_ADDRESS, {}, payload)

export const getAppointmentSlots = async (payload) =>
  makeRequest('POST', endpoints.Diagnostics.GET_APPOINTMENT_SLOTS, {}, payload)

export const bookTest = async (payload) =>
  makeRequest('POST', endpoints.Diagnostics.BOOK_TEST, {}, payload)

export const confirmOrder = async (payload) =>
  makeRequest('POST', endpoints.Diagnostics.CONFIRM_ORDER, {}, payload)

export const getRecords = async (payload) =>
  makeRequest('POST', endpoints.Diagnostics.GET_RECORDS, {}, payload)

// PINCODE APIS
export const getLatLongByPincode = async (payload) =>
  makeRequest('GET', `${endpoints.Pincodes.GET_LAT_LONG_BY_PINCODE}/${payload}`)

// PNDS APIS
export const generatePndsScore = async (formData) =>
  makeRequest('POST', endpoints.PNDS.GENERATE_PNDS_SCORE, {}, formData, true)

//Care plan APIS
export const getCarePlans = async (params) =>
  makeRequest('GET', endpoints.CarePlan.FETCH_CARE_PLANS, params)

export const sendEventDataAPI = async (payload) =>
  makeRequest('POST', endpoints.SendEventData.SEND_DATA, {}, payload)
